import React, { useEffect } from "react";

const MessengerChat = () => {
  useEffect(() => {
    // Check if Facebook SDK is already loaded
    if (window.FB) {
      window.FB.XFBML.parse();
      return;
    }

    // Load the Facebook SDK
    const script = document.createElement("script");
    script.src = "https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js";
    script.async = true;
    script.defer = true;
    script.onload = () => {
      window.FB.init({
        xfbml: true,
        version: "v18.0", // Use the latest API version
      });
    };

    document.body.appendChild(script);
  }, []);

  return (
    <>
      {/* Messenger Chat Plugin */}
      <div
        className="fb-customerchat"
        attribution="setup_tool"
        page_id="122103596378006994" // Replace with your actual Page ID
      ></div>
    </>
  );
};

export default MessengerChat;
